import React, { Fragment, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useDispatch, useSelector } from "react-redux";
import { addDetailsAction, clearErrors, loadUserAction, } from "../../../redux/actions/userActions";
import Loader from '../../loader/loader';
import Logo from "../../images/logo-black.png"

import { ADD_DETAILS_RESET } from '../../../redux/constants/userConstant';
import { uploadToCloudinary } from '../../../utils/uploadToCloudinary';
import store from "../../../store"
import BasicInfo from './BasicInfo';
import Address from './Address';
import BankDetails from './BankDetails';
import Verification from './Verification';




const AdditionalInformation = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();


  const { loading, error, message } = useSelector((state) => state.inviteUser);
  const { isAuthenticated, user, loading: userLoading } = useSelector((state) => state.verifyEmailStore);
  const { loading: disableButton } = useSelector((state) => state.upload);




  const [counteryCode, setCounteryCode] = useState("+92")
  const [phone_number, setPhoneNumber] = useState("")
  const [avatar_url, setAvatar_url] = useState()
  const [avatarPreview, setAvatarPreview] = useState()
  const [fb_link, setFb_link] = useState()
  const [cnic_front_url, setCnic_front_url] = useState()
  const [cnic_front_preview, setCnic_front_preview] = useState()
  const [cnic_back_url, setCnic_back_url] = useState()
  const [cnic_back_preview, setCnic_back_preview] = useState()
  const [cnic_number, setcnic_number] = useState("")
  const [street_address, setstreet_address] = useState("")
  const [city, setcity] = useState("")
  const [state, setstate] = useState("")
  const [bank_name, setbank_name] = useState("")
  const [account_title, setaccount_title] = useState("")
  const [account_number, setaccount_number] = useState("")
  const [basicInfo, setBasicInfo] = useState(false)
  const [address, setAddress] = useState(false)
  const [bankDetails, setBankDetails] = useState(false)
  const [verification, setVerification] = useState(false)



  const handleSubmit = async (e) => {
    e.preventDefault()




    if (!counteryCode) return toast.error("Please enter country code");
    if (!phone_number) return toast.error("Please enter Whatsapp number");
    if (!avatar_url && !avatarPreview) return toast.error("Please upload avatar");
    if (!cnic_front_url && !cnic_front_preview) return toast.error("Please upload front side of cnic");
    if (!cnic_back_url && !cnic_back_preview) return toast.error("Please upload back side of cnic");

    if (!street_address) return toast.error("Please enter street address");
    if (!city) return toast.error("Please enter city");
    if (!state) return toast.error("Please enter state");
    if (!bank_name) return toast.error("Please enter bank name");
    if (!account_title) return toast.error("Please enter account title");
    if (!account_number) return toast.error("Please enter account number");
    if (!cnic_number) return toast.error("Please enter CNIC number");







    try {



      const files = [
        avatar_url,
        cnic_front_url,
        cnic_back_url
      ].filter(Boolean);

      const total = files.length;



      // ✅ START ONCE
      store.dispatch({ type: "UPLOAD_START" });

      let uploaded = [];

      for (let i = 0; i < files.length; i++) {


        const url = await uploadToCloudinary(
          files[i],
          "avatars",
          i + 1,
          total
        );

        uploaded.push(url);
      }

      const [profileImageURL, CnicFrontURL, CnicBackURL] = uploaded;





      const data = {

        countryCode: counteryCode,
        phone_number,
        avatar_url: profileImageURL,
        fb_link,
        cnic_front_url: CnicFrontURL,
        cnic_back_url: CnicBackURL,
        street_address,
        city,
        state,
        bank_name,
        account_title,
        account_number,
        cnic_number,
      };


      store.dispatch({ type: "UPLOAD_END" });



      dispatch(addDetailsAction(data))




    } catch (err) {


      store.dispatch({ type: "UPLOAD_RESET" });


      toast.error("Images upload failed. Please Check your Internet Connection and then try again. ");
    }




  }



  useEffect(() => {
    if (message) {
      toast.success(message);
      dispatch({ type: ADD_DETAILS_RESET })
      dispatch(loadUserAction())
      navigate("/")
    }
    if (error) {
      toast.error(error);
      dispatch(clearErrors());
    }
  }, [error, message, navigate, dispatch, isAuthenticated]);




  useEffect(() => {

    document.title = 'USER DETAILS'

  }, [])



  const handleFileChange = (setImage, setPreview) => (e) => {
    const file = e.target.files[0];

    if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
      setImage(file);
      setPreview(URL.createObjectURL(file));
    } else {
      alert("Only PNG and JPG files are allowed!");
    }
  };



  useEffect(() => {
    if (user) {
      setCounteryCode(user.country_code || "+92")
      setPhoneNumber(user.phone_number || "")
      setAvatarPreview(user.avatar_url || "")
      setFb_link(user.fb_link || "")
      setCnic_front_preview(user.cnic_front_url || "")
      setCnic_back_preview(user.cnic_back_url || "")

      setstreet_address(user.street_address || "")
      setcity(user.city || "")
      setstate(user.state || "")
      setbank_name(user.bank_name || "")
      setaccount_title(user.account_title || "")
      setaccount_number(user.account_number || "")
      setcnic_number(user.cnic_number || "")


    }
  }, [user])



  useEffect(() => {

    if (counteryCode && phone_number && avatarPreview) {
      setBasicInfo(true)
    } else {
      setBasicInfo(false)
    }

    if (street_address && city && state) {
      setAddress(true)
    } else {
      setAddress(false)
    }

    if (bank_name && account_title && account_number) {
      setBankDetails(true)
    } else {
      setBankDetails(false)
    }

    if (cnic_number && cnic_front_preview && cnic_back_preview) {
      setVerification(true)
    } else {
      setVerification(false)
    }


  }, [counteryCode, phone_number, avatarPreview, street_address, city, state, bank_name, account_title, account_number, cnic_number, cnic_front_preview, cnic_back_preview])




  return (
    <Fragment>
      {(loading || userLoading) ? <Loader /> :
        <>          <section className="relative min-h-[100vh] bg-zinc-50 font-jakarta overflow-hidden py-12 px-4 lg:px-8">
            <div className="max-w-6xl mx-auto">
              
              {/* Header */}
              <div className="flex flex-col items-center mb-12">
                <img src={Logo} alt="Zonify Pro" className="w-40 mb-6" />
                <h1 className="text-3xl lg:text-4xl font-bold text-zinc-900 mb-2">Complete your Profile</h1>
                <p className="text-sm lg:text-base text-zinc-500 text-center max-w-md">
                  Please fill in your details to complete your registration and get access to the portal.
                </p>
              </div>

              {/* Steps Indicator */}
              <div className="bg-white rounded-xl shadow-sm border border-zinc-200 p-6 mb-8">
                <div className="flex flex-col lg:flex-row justify-between items-center gap-4 lg:gap-0">
                  
                  {/* Step 1 */}
                  <div className="flex items-center gap-3 w-full lg:w-auto">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold text-sm transition-colors ${basicInfo ? 'bg-zinc-900 text-white' : 'bg-zinc-100 text-zinc-500'}`}>
                      1
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-zinc-900">Personal Info</h3>
                      <p className="text-xs text-zinc-500">Basic info</p>
                    </div>
                  </div>
                  
                  <div className="hidden lg:block h-[1px] bg-zinc-200 flex-1 mx-6"></div>

                  {/* Step 2 */}
                  <div className="flex items-center gap-3 w-full lg:w-auto">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold text-sm transition-colors ${address ? 'bg-zinc-900 text-white' : 'bg-zinc-100 text-zinc-500'}`}>
                      2
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-zinc-900">Address</h3>
                      <p className="text-xs text-zinc-500">Your Location</p>
                    </div>
                  </div>

                  <div className="hidden lg:block h-[1px] bg-zinc-200 flex-1 mx-6"></div>

                  {/* Step 3 */}
                  <div className="flex items-center gap-3 w-full lg:w-auto">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold text-sm transition-colors ${bankDetails ? 'bg-zinc-900 text-white' : 'bg-zinc-100 text-zinc-500'}`}>
                      3
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-zinc-900">Bank Details</h3>
                      <p className="text-xs text-zinc-500">Account Info</p>
                    </div>
                  </div>

                  <div className="hidden lg:block h-[1px] bg-zinc-200 flex-1 mx-6"></div>

                  {/* Step 4 */}
                  <div className="flex items-center gap-3 w-full lg:w-auto">
                    <div className={`w-10 h-10 rounded-full flex items-center justify-center font-semibold text-sm transition-colors ${verification ? 'bg-zinc-900 text-white' : 'bg-zinc-100 text-zinc-500'}`}>
                      4
                    </div>
                    <div>
                      <h3 className="text-sm font-semibold text-zinc-900">Verification</h3>
                      <p className="text-xs text-zinc-500">Cnic Verification</p>
                    </div>
                  </div>

                </div>
              </div>

              {/* Form Content */}
              <form onSubmit={handleSubmit} className="space-y-8">
                
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                  <BasicInfo
                    counteryCode={counteryCode}
                    phone_number={phone_number}
                    fb_link={fb_link}
                    avatar_url={avatar_url}
                    avatarPreview={avatarPreview}
                    setCounteryCode={setCounteryCode}
                    setPhoneNumber={setPhoneNumber}
                    setFb_link={setFb_link}
                    setAvatar_url={setAvatar_url}
                    setAvatarPreview={setAvatarPreview}
                    handleFileChange={handleFileChange}
                  />
                  <Address
                    street_address={street_address}
                    city={city}
                    state={state}
                    setstreet_address={setstreet_address}
                    setcity={setcity}
                    setstate={setstate}
                  />

                  <BankDetails
                    bank_name={bank_name}
                    account_title={account_title}
                    account_number={account_number}
                    setbank_name={setbank_name}
                    setaccount_title={setaccount_title}
                    setaccount_number={setaccount_number}
                  />
                  <Verification
                    cnic_number={cnic_number}
                    cnic_front_url={cnic_front_url}
                    cnic_back_url={cnic_back_url}
                    cnic_front_preview={cnic_front_preview}
                    cnic_back_preview={cnic_back_preview}
                    setcnic_number={setcnic_number}
                    setCnic_front_url={setCnic_front_url}
                    setCnic_back_url={setCnic_back_url}
                    setCnic_front_preview={setCnic_front_preview}
                    setCnic_back_preview={setCnic_back_preview}
                    handleFileChange={handleFileChange}
                  />
                </div>

                {/* Data Protected Notice */}
                <div className="bg-white border border-zinc-200 rounded-xl p-4 flex items-center gap-4 shadow-sm">
                  <div className="w-10 h-10 rounded-full bg-zinc-900 flex items-center justify-center text-white flex-shrink-0">
                    <i className="fa-solid fa-shield-halved text-sm"></i>
                  </div>
                  <div>
                    <h3 className="text-sm font-semibold text-zinc-900">Your Data is Protected</h3>
                    <p className="text-xs text-zinc-500">
                      We use industry-standard encryption to keep your data secure and safe.
                    </p>
                  </div>
                </div>

                {/* Submit Button */}
                <div className="flex justify-center">
                  <button
                    type="submit"
                    className={`px-6 py-3 rounded-lg font-medium text-sm lg:text-base transition-all flex items-center gap-2
                      ${disableButton ? 
                        'bg-zinc-100 text-zinc-400 cursor-not-allowed' : 
                        'bg-zinc-900 text-white hover:bg-zinc-800 shadow-sm hover:shadow-md'}`}
                    disabled={disableButton}
                  >
                    Save & Continue
                    <i className="fa-solid fa-arrow-right-long text-xs"></i>
                  </button>
                </div>
              </form>
            </div>
          </section>
        </>
      }

    </Fragment >

  )
}

export default AdditionalInformation